<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="4">
        <blockquote class="blockquote" v-text="this.$t('quote')"></blockquote>
        <v-container v-html="this.$t('home-html')"> </v-container>
      </v-col>
      <v-col cols="12" md="8"> <ImgCarousel align="center"/></v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImgCarousel from "@/components/ImgCarousel.vue";
export default {
  name: "Home",
  components: {
    ImgCarousel
  }
};
</script>

<style scoped>
blockquote {
  font-family: Georgia, serif;
  font-size: 18px;
  font-style: italic;

  margin: 0.25em 0;
  padding: 0.35em 40px;
  line-height: 1.45;
  position: relative;
  color: #383838;
}

blockquote::before {
  display: block;
  padding-left: 10px;
  content: "\201C";
  font-size: 80px;
  position: absolute;
  left: -30px;
  top: -30px;
  color: #7a7a7a;
}

blockquote cite {
  color: #999999;
  font-size: 14px;
  display: block;
  margin-top: 5px;
}

blockquote cite::before {
  content: "\2014 \2009";
}
</style>
